import React, { useState, useEffect } from "react";
import {
  ArrowRight,
  Shield,
  FileText,
  Search,
  ShoppingBag,
  Building2,
  Award,
  Zap,
  DollarSign,
  HeadphonesIcon,
  CheckCircle,
} from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { Link } from "react-router-dom";

const iconMap = {
  Shield,
  FileText,
  Search,
  ShoppingBag,
  Building2,
  Award,
  Zap,
  DollarSign,
  HeadphonesIcon,
  CheckCircle,
};

const ServiceSlider = ({ services }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 664) {
        setItemsPerPage(1);
      } else if (window.innerWidth < 1024) {
        setItemsPerPage(2);
      } else {
        setItemsPerPage(3);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const getVisibleServices = () => {
    const result = [];
    for (let i = 0; i < itemsPerPage; i++) {
      const index = (currentIndex + i) % services.length;
      result.push(services[index]);
    }
    return result;
  };

  return (
    <div className="relative">
      <div
        className={`grid gap-8 ${itemsPerPage === 1 ? "grid-cols-1" : itemsPerPage === 2 ? "md:grid-cols-2" : "md:grid-cols-2 lg:grid-cols-3"}`}
      >
        {getVisibleServices().map((service, index) => {
          const Icon = iconMap[service.icon];
          return (
            <Card
              key={`${service.id}-${currentIndex}`}
              className="h-full hover:shadow-xl transition-all duration-500 hover:-translate-y-2 group"
            >
              <CardHeader>
                <div className="w-14 h-14 bg-gradient-to-br from-brand-purple/10 to-brand-pink/10 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                  <Icon className="w-7 h-7 text-brand-purple" />
                </div>
                <CardTitle className="text-xl group-hover:text-brand-purple transition-colors">
                  {service.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 mb-4">{service.description}</p>
                <Link to={service.link}>
                  <Button
                    size="lg"
                    className="bg-gradient-to-r from-brand-purple to-brand-pink hover:opacity-90 text-white w-full"
                  >
                    Learn More
                    <ArrowRight className="ml-2 w-5 h-5" />
                  </Button>
                </Link>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {services.length > itemsPerPage && (
        <div className="flex justify-center gap-3 mt-8">
          {Array.from({ length: services.length }).map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index === currentIndex
                  ? "bg-brand-purple w-8"
                  : "bg-gray-300 hover:bg-brand-purple/50"
              }`}
              aria-label={`Go to service ${index + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ServiceSlider;
